import {
    PosMicrosIntegrationAccountingCategoryListItem,
    PosMicrosIntegrationMicros4700Outlet,
    PosMicrosIntegrationXmlPosOutlet,
} from '@mews-commander/data-access';

const mapAccountingCategoriesListItem = (
    items: PosMicrosIntegrationAccountingCategoryListItem[]
): PosMicrosIntegrationAccountingCategoryListItem[] => {
    return items.map((item) => ({
        categoryId: item.categoryId,
        taxCodes: item.taxCodes || [],
    }));
};

export const getMicrosOutletValue = (
    defaultValues: PosMicrosIntegrationMicros4700Outlet,
    microsOutlet?: PosMicrosIntegrationMicros4700Outlet
): PosMicrosIntegrationMicros4700Outlet => {
    const microsOutletValue = microsOutlet || defaultValues;
    return {
        ...microsOutletValue,
        netSalesAccountingCategories: mapAccountingCategoriesListItem(
            microsOutletValue.netSalesAccountingCategories || []
        ),
    };
};

export const getXmlMicrosOutletValue = (
    defaultValues: PosMicrosIntegrationXmlPosOutlet,
    microsOutlet?: PosMicrosIntegrationXmlPosOutlet
): PosMicrosIntegrationXmlPosOutlet => {
    const microsOutletValue = microsOutlet || defaultValues;
    const serviceTimes = microsOutlet?.serviceTimes || defaultValues?.serviceTimes || [];

    return {
        ...microsOutletValue,
        serviceTimes: serviceTimes.map((serviceTime) => ({
            ...serviceTime,
            netSalesAccountingCategories: mapAccountingCategoriesListItem(
                serviceTime.netSalesAccountingCategories || []
            ),
            discountAccountingCategories: mapAccountingCategoriesListItem(
                serviceTime.discountAccountingCategories || []
            ),
            serviceChargeAccountingCategories: mapAccountingCategoriesListItem(
                serviceTime.serviceChargeAccountingCategories || []
            ),
        })),
    };
};
